import RestAPI from 'components/Common/restApi';
import { saveAs } from 'file-saver';

export default class QuickbooksApi {
  static connectQBOOnCustomerList() {
    return RestAPI.get('/pro/quickbooks/auth_on_customer_list');
  }

  static fetchQuickbooksConnectionStatus() {
    return RestAPI.get('/alpha/quickbooks_online/connection/status');
  }

  static fetchQBOProcesses({ expand, page, pageSize: page_size, filters } = {}) {
    const params = { expand, page, page_size, filters };
    return RestAPI.getWithQueryString('/alpha/quickbooks_online/processes', params);
  }

  static downloadRollbackReport(id) {
    return RestAPI.get(`/alpha/quickbooks_online/processes/${id}/rollback_report`).then((response) => {
      saveAs(new File([response.data], `rollback_report_${id}.csv`, { type: 'text/csv' }));
    });
  }

  static updateCCReconciliationAccount(id) {
    return RestAPI.updateWithFormData('/pro/quickbooks/account_info/credit_card_destination_account', {
      bank_account_id: id,
    });
  }

  static importQBOAll({ fromDate: from_date } = {}) {
    const params = { from_date };
    return RestAPI.getWithQueryString('/pro/quickbooks/import_all', params);
  }

  static fetchQBOLinkedDataSummary() {
    return RestAPI.get('/alpha/quickbooks_online/linked_data_summary');
  }
}
